import React from 'react';
import classnames from 'classnames';
import IgniteBarChart from '@ignitesales/react-bar-chart';
import { parseAnswerValue } from '../../../util/questionUtil.jsx';
import { FormattedMessage, useIntl } from 'react-intl';
import { formatCurrency } from '../../../util/format.mjs';
import PropTypes from 'prop-types';
import {QuestionGroupViewPropTypes} from '../../../shapes/index';

const BarChart = (props) => {
  const {
    className,
    questionGroup,
    page,
    colorMap
  } = props;

  const intl = useIntl();

  const answers = page.answers;
  const attributes = questionGroup.attributes || {};

  const formatValue = (format, value) => {
    if (value) {
      switch (format) {
        case '%':
        case 'percent':
          return value ? `${ value }%` : '';
        case '$':
        case 'money':
        case 'currency':
          return value ? formatCurrency(value || 0) : '';
        case 'pctOfRevenue':
          return formatCurrency(Math.round(((value || 0) * parseInt(answers.annualRevenue.value || 0)) / 100));
        default:
          return value;
      }
    } else {
      return '';
    }
  };

  const tickFormatter = value => formatValue(attributes.tickerFormat || attributes.format, value);
  const getBarLabel = value => formatValue(attributes.format || attributes.tickerFormat, value);

  const getTitleValue = () => {
    const answer = answers[attributes.titleValueKey] || {};
    return answer.value ? parseAnswerValue(intl, answer) : '';
  };

  const prepareData = () => {
    const questions = page.questionGroups.reduce((a, c) => a.concat(c.questions), [])
      .filter(q => q && (q.type !== 'calculated'))
      .map(q => q.appkey);

    return (attributes.fields || []).filter(f => questions.indexOf(f) >= 0).map(f => {
      const field = answers[f];
      const x = ''; //Math.floor(Math.random()*5000);
      return field ? {
        key: field.appkey,
        value: field.value,
        label: intl.formatMessage({ id: field.appkey }),
        barLabel: getBarLabel(field.value),
        toolTip: formatValue(attributes.tickerFormat || attributes.format, field.value)
      } : {
        key: f,
        value: x,
        label: intl.formatMessage({ id: f }),
        barLabel: getBarLabel(x),
        toolTip: formatValue(attributes.tickerFormat || attributes.format, x)
      };
    });
  };

  const classes = classnames(className, {
    'barChartGroup': true,
  });

  return (
    <section className={ classes }>
      <span className="barChartGroup__title"><FormattedMessage
        id={ questionGroup.key }
        values={ { v: getTitleValue() } }
      /></span>
      <IgniteBarChart
        tickFormatter={ tickFormatter }
        labelFormatter={ getBarLabel }
        data={ prepareData() }
        colors={ colorMap }
        vertical={ attributes.vertical }
        showX={ attributes.showX }
        showY={ attributes.showY }
        format={ attributes.format }
      />
    </section>
  );
};

BarChart.propTypes = {
  ...QuestionGroupViewPropTypes,
  page: PropTypes.any,
  colorMap: PropTypes.any
};

export default BarChart;
